package one.healthium.med.di

import one.healthium.base.di.baseUtilsModule
import one.healthium.common.di.dataCommonModule
import one.healthium.db.di.appDatabaseModule
import one.healthium.di.sharedModule
import one.healthium.events.di.eventsModule
import one.healthium.featureconfig.di.featureConfigModule
import one.healthium.firebase.di.firebaseModule
import one.healthium.insights.di.insightsModule
import one.healthium.log_food.di.logFoodModule
import one.healthium.log_water.di.waterIntakeModule
import one.healthium.log_weight.di.logWeightModule
import one.healthium.login.di.loginUiModule
import one.healthium.onboarding.di.onboardingModule
import one.healthium.uscreen.di.uscreenDataModule
import one.healthium.uscreen.ui.di.uscreenUiModule
import one.healthium.payments.di.paymentsModule
import one.healthium.paywall.di.paywallModule
import one.healthium.profile.di.profileUiModule
import one.healthium.promo_banner.di.promoBannerModule
import one.healthium.rateus.di.rateUsModule
import one.healthium.settings.di.settingsModule
import one.healthium.tasks.di.dailyTasksUiModule
import one.healthium.today.di.todayUiMedModule
import one.healthium.healthKit.di.healthKitModule
import one.healthium.log_symptoms.di.logSymptomsUiModule
import one.healthium.meal_plans.tutorial.di.mealPlanTutorialModule
import one.healthium.reminders.di.remindersUiModule
import one.healthium.tutorial.di.tutorialUiModule
import one.healthium.update_food_preferences.di.updateFoodPreferencesModule
import one.primehealth.analytics.di.analyticsModule
import one.primehealth.app.Flavour
import one.primehealth.app.di.baseAppModule
import org.koin.core.KoinApplication
import org.koin.core.context.startKoin
import org.koin.dsl.KoinAppDeclaration
import org.koin.dsl.module

fun initKoin(flavour: Flavour, declaration: KoinAppDeclaration = {}): KoinApplication {
    return startKoin {
        declaration()

        modules(
            module { single { flavour } },
            composeModule,
            sharedModule,
            paymentsModule,
            baseUtilsModule,
            dataCommonModule,
            insightsModule,
            todayUiMedModule,
            settingsModule,
            paywallModule,
            dailyTasksUiModule,
            appDatabaseModule,
            logFoodModule,
            waterIntakeModule,
            logWeightModule,
            profileUiModule,
            loginUiModule,
            onboardingModule,
            uscreenDataModule,
            uscreenUiModule,
            baseAppModule,
            rateUsModule,
            analyticsModule,
            healthKitModule,
            tutorialUiModule,
            logSymptomsUiModule,
            remindersUiModule,
            promoBannerModule,
            eventsModule,
            updateFoodPreferencesModule,
            mealPlanTutorialModule,
            featureConfigModule,
            firebaseModule,
        )
    }
}
